import { Link, useLoaderData } from "react-router-dom";
import { PageTitle                } from "./Controls/PageTitle";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import { PaymentMethodResp } from "./Data/ApiTypes";
import { PaymentMethodDisplay } from "./Controls/PaymentMethod";
import { CreditCard2Front } from "react-bootstrap-icons";

export function UserBillingPage() {
    const methods = useLoaderData() as PaymentMethodResp[];
    const [paymentMethods, setPaymentMethods] = useState<PaymentMethodResp[]>( methods );

    return <Container fluid>
        <Row>
            <Col md="12">
                <div className="d-flex align-items-center gap-2">
                    <PageTitle className="d-flex align-items-center gap-2">
                        Payment Methods
                        <Link to="https://docs.stripe.com/security" target="_blank" rel="noopener noreferrer">
                            <img src="/img/powered-by-stripe.svg" style={{ height: "1.1em" }} />
                        </Link>
                    </PageTitle>
                </div>
                <div className="text-secondary">
                    Your information is securely stored by <b>Stripe</b>
                </div>
                <div className="my-2">
                    {/* <Hyperlink to="/user/billing/add">
                        Add Payment Method
                    </Hyperlink> */}
                </div>
                <Container className="g-0">
                    <Row className="gap-3 mt-3">
                        {paymentMethods.length === 0 && (
                            <Col xs="12">
                                <div className="card border-0" style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.07)" }}>
                                    <div className="card-body text-center text-muted py-5" style={{ fontSize: "0.9rem" }}>
                                        <div
                                            className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                            style={{ width: 72, height: 72, backgroundColor: "rgba(220, 53, 130, 0.12)" }}
                                        >
                                            <CreditCard2Front size={30} style={{ color: "rgba(220, 53, 130, 0.5)" }} />
                                        </div>
                                        <div className="fw-semibold mb-1">No payment methods saved.</div>
                                        <div>Payment methods you save after making a successful payment will appear here.</div>
                                    </div>
                                </div>
                            </Col>
                        )}
                        {paymentMethods.length > 0 && paymentMethods.map( p => {
                            return <Col key={p.paymentMethodId} md="auto" className="d-flex justify-items-center justify-content-center zoom-small">
                                <Link to={`/user/billing/${p.paymentMethodId}`}>
                                    <PaymentMethodDisplay method={p} />
                                </Link>
                            </Col>;
                        } )}
                    </Row>
                </Container>
            </Col>
        </Row>
    </Container>;
}